import { useCallback, useEffect, useMemo } from "react";
import { apiNiches } from "@/common/services";
import { INiche } from "@/common/services/types";
import { isAuthenticated } from "@/common/services/Auth";
import { useFetch } from "@/common/hooks/useFetch";

export const useSuggestedNiches = () => {
  const fetchSuggestedNiches = useCallback(() => apiNiches.getSuggestedNiches(), []);
  const { data: niches, isLoading, error, execute } = useFetch(fetchSuggestedNiches, false);

  useEffect(() => {
    (async () => {
      try {
        if (await isAuthenticated()) {
          execute();
        }
      }
      catch (e) {
        console.error("Error reading niches.", e);
      }
    })();
  }, []);

  const suggestedNiches = useMemo(() =>
    niches?.map((el: INiche) => ({
      id: el.id,
      name: el.name,
      image: el.thumbnail,
      subscribers: el.subscribers,
    })) || [], [niches]);

  return {
    niches: suggestedNiches,
    error,
    isLoading
  };
};

